export default "__VITE_ASSET__7YGuWPKp__"